import { useQuery, UseQueryResult } from '@taxdown/zeno-sama-query';
import CheckoutService from 'Services/checkout';
import { QueryKeys, CepResponse, ResponseType } from 'Types/common';

export const useGetCep = ({
  trackId,
}: {
  trackId?: string;
}): UseQueryResult<ResponseType<CepResponse>> =>
  useQuery([QueryKeys.GET_CEP], () => CheckoutService.getCep({ trackId: trackId || '' }), {
    enabled: false,
    retry: false,
    refetchOnWindowFocus: false,
  });
